<!-- The dialog box that will appear when we go offline -->
<ng-template #offlineDialog>
  <div>
    <div class="sg-flex-column sg-fill sg-justify-start sg-items-center">
      <h1 class="mat-display-2 sg-no-margin" translate>NOCONN.title</h1>
      <br />
      <span class="mat-subheading-2" translate>NOCONN.desc</span>
      <span class="sg-color-disabled" translate>NOCONN.footer</span>
    </div>
  </div>
</ng-template>
<sg-input
  *globalMaterialFormControl="'sg-input'; let ctx"
  [formControl]="ctx.fControl"
  [type]="ctx.item?.data?.type"
  [variant]="ctx.item?.data?.variant"
  [size]="ctx.item?.data?.size"
  [width]="ctx.item?.data?.width"
  [label]="ctx.item?.label"
  [placeholder]="ctx.item?.data?.placeholder"
  [hideLabel]="ctx.item?.data?.hideLabel"
  [errorsMap]="ctx.item?.data?.errorsMap"
  [hint]="ctx.item?.data?.hint"
  [maxLimit]="ctx.item?.data?.maxLimit"
  [prefix]="ctx.item?.data?.prefix"
  [prefixIcon]="ctx.item?.data?.prefixIcon"
  [suffix]="ctx.item?.data?.suffix"
  [showSuffixAction]="ctx.item?.data?.showSuffixAction"
  [clearButton]="ctx.item?.data?.clearButton"
  [numberStep]="ctx.item?.data?.numberStep"
  [submitButtonIcon]="ctx.item?.data?.submitButtonIcon"
  [submitButtonIsLoading]="ctx.item?.data?.submitButtonIsLoading"
  (valueSubmitted)="ctx.item?.data ? ctx.item.data.valueSubmitted = $event : null"></sg-input>
<sg-toggle
  *globalMaterialFormControl="'sg-toggle'; let ctx;"
  [label]="ctx.item?.data?.noLabel ? '' : ctx.item.label"
  [formControl]="ctx.fControl"
  [size]="ctx.item?.data?.size || 'default'"></sg-toggle>
<sg-dropdown
  *globalMaterialFormControl="'sgDropdown'; let ctx;"
  [label]="ctx.item?.data?.noLabel ? '' : ctx.item.label"
  [placeholder]="ctx.item?.data?.placeholder"
  [formControl]="ctx.fControl"
  [items]="ctx.item?.data?.options"
  [size]="ctx.item?.data?.size || 'default'"></sg-dropdown>
<sg-textarea
  *globalMaterialFormControl="'sg-textarea'; let ctx"
  [formControl]="ctx.fControl"
  [variant]="ctx.item?.data?.variant"
  [width]="ctx.item?.data?.width"
  [label]="ctx.item?.label"
  [placeholder]="ctx.item?.data?.placeholder"
  [hideLabel]="ctx.item?.data?.hideLabel"
  [errorsMap]="ctx.item?.data?.errorsMap"
  [hint]="ctx.item?.data?.hint"
  [maxLimit]="ctx.item?.data?.maxLimit"
  [rows]="ctx.item?.data?.rows"
  [minRows]="ctx.item?.data?.minRows"
  [maxRows]="ctx.item?.data?.maxRows"
  [autoResize]="ctx.item?.data?.autoResize"
  [subscriptSizing]="ctx.item?.data?.subscriptSizing"
  [errorFallbackMessage]="ctx.item?.data?.errorFallbackMessage"></sg-textarea>
